const state = {
  clientWidth: "",
};
const mutations = {
  SET_CLIENTWIDTH(state, data) {
    state.clientWidth = data;
  },
};
export default {
    state,
    mutations
}